import PriorityChip from './PriorityChip';
import getPriorityColor from './priorityColor.utils';

export * from './PriorityChip.types';
export { getPriorityColor, PriorityChip };
export default PriorityChip;
